import React from 'react';
import { Card } from './ui/Card';
import { LineChart, Map, Briefcase, Handshake, Network, Globe, Database, BarChart3, Rocket } from 'lucide-react';
export function ExpertiseGrid() {
  const expertise = [{
    name: 'Revenue Growth Strategy',
    icon: <LineChart className="w-6 h-6" data-id="element-150" />
  }, {
    name: 'Go-to-Market Strategy',
    icon: <Map className="w-6 h-6" data-id="element-151" />
  }, {
    name: 'Enterprise Sales Leadership',
    icon: <Briefcase className="w-6 h-6" data-id="element-152" />
  }, {
    name: 'Strategic Partnerships',
    icon: <Handshake className="w-6 h-6" data-id="element-153" />
  }, {
    name: 'Sales Organization Build-Out',
    icon: <Network className="w-6 h-6" data-id="element-154" />
  }, {
    name: 'Channel & Distribution',
    icon: <Globe className="w-6 h-6" data-id="element-155" />
  }, {
    name: 'CRM & Revenue Infrastructure',
    icon: <Database className="w-6 h-6" data-id="element-156" />
  }, {
    name: 'Board-Level Reporting',
    icon: <BarChart3 className="w-6 h-6" data-id="element-157" />
  }, {
    name: 'Market Expansion',
    icon: <Rocket className="w-6 h-6" data-id="element-158" />
  }];
  return <section id="expertise" className="py-24 bg-navy-950" data-id="element-159">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="mb-16 md:text-center" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-162">
            Core <span className="text-gradient" data-id="element-163">Expertise</span>
          </h2>
          <p className="text-lg text-white/50 max-w-2xl mx-auto" data-id="element-164">
            Comprehensive commercial capabilities driving enterprise value.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-165">
          {expertise.map((item, index) => <Card key={index} hover className="p-6 flex items-center gap-4 group" data-id="element-166">
              <div className="w-12 h-12 rounded-lg bg-navy-800 flex items-center justify-center text-white/40 group-hover:text-gold group-hover:bg-gold/10 transition-colors" data-id="element-167">
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold text-white/80 group-hover:text-white transition-colors" data-id="element-168">
                {item.name}
              </h3>
            </Card>)}
        </div>
      </div>
    </section>;
}